import ChatPauseEvent from './ChatPauseEvent';
import ChatUnpauseEvent from './ChatUnpauseEvent';
import VoicePauseEvent from './VoicePauseEvent';
import VoiceUnpauseEvent from './VoiceUnpauseEvent';
import PauseTimeoutExpiredEvent from './PauseTimeoutExpiredEvent';
import WhatsAppPauseEvent from './WhatsAppPauseEvent';
import WhatsAppUnpauseEvent from './WhatsAppUnpauseEvent';

export default {
  ChatPauseEvent,
  ChatUnpauseEvent,
  VoicePauseEvent,
  VoiceUnpauseEvent,
  PauseTimeoutExpiredEvent,
  WhatsAppPauseEvent,
  WhatsAppUnpauseEvent,
};
